import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { AssignSelect } from "@/components/ProsManager";

export function ConsultRow({ c, onSaved, base = "/admin/consultations", assign }) {
  const [f, setF] = useState({ status: c.status, pro_notes: c.pro_notes || "" });
  const save = async () => {
    try { onSaved((await api.patch(`${base}/${c.consult_id}`, f)).data); toast.success("Consultation updated"); } catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className="p-5 space-y-2" data-testid={`admin-consult-${c.consult_id}`}>
      <div className="flex justify-between gap-2 flex-wrap"><span className="font-semibold text-slate-900">{c.service_name}</span><span className="text-xs text-slate-500">{[c.user_email, c.preferred_contact].filter(Boolean).join(" · ")}</span></div>
      {assign}
      <p className="text-sm text-slate-600">{c.topic}</p>
      <div className="flex flex-col md:flex-row gap-2">
        <Select value={f.status} onValueChange={(v) => setF({ ...f, status: v })}>
          <SelectTrigger className="md:w-40" data-testid={`admin-consult-status-${c.consult_id}`}><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="submitted">Submitted</SelectItem><SelectItem value="scheduled">Scheduled</SelectItem><SelectItem value="completed">Completed</SelectItem></SelectContent>
        </Select>
        <Textarea rows={1} placeholder="Notes to client (assigned pro, meeting time, summary)" value={f.pro_notes} onChange={(e) => setF({ ...f, pro_notes: e.target.value })} data-testid={`admin-consult-notes-${c.consult_id}`} />
        <Button onClick={save} className="bg-emerald-600 hover:bg-emerald-700" data-testid={`admin-consult-save-${c.consult_id}`}>Save</Button>
      </div>
    </div>
  );
}

export function ConsultQueue() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/consultations").then((r) => setItems(r.data)); }, []);
  return (
    <div className="mt-12">
      <h2 className="font-display text-2xl font-bold text-slate-900 mb-4">CPA & attorney requests</h2>
      {items.length === 0 ? <p className="text-slate-500 text-sm" data-testid="admin-consults-empty">No paid consultation requests yet.</p> : (
        <div className="bg-white border border-slate-200 rounded-lg divide-y divide-slate-100">
          {items.map((c) => {
            const up = (n) => setItems((xs) => xs.map((x) => (x.consult_id === n.consult_id ? n : x)));
            return <ConsultRow key={c.consult_id} c={c} onSaved={up} assign={<AssignSelect kind="consult" item={c} proType={c.service === "cpa_consult" ? "cpa" : "attorney"} onAssigned={up} />} />;
          })}
        </div>
      )}
    </div>
  );
}
